import { createContext, useContext } from "react";
const defaultContext = {
    formTemplateId: undefined
};
export const templateFormContext = createContext(defaultContext);
templateFormContext.displayName = "TemplateForm";
export const useFormTemplate = () => useContext(templateFormContext);
export const FormTemplateProvider = templateFormContext.Provider;
export const FormTemplateConsumer = templateFormContext.Consumer;
//# sourceMappingURL=FormTemplateContext.js.map